import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type StoreService from 'scaleflow/services/store';
import type IntlService from 'ember-intl/services/intl';
import type RoleModel from 'scaleflow/models/role';

export default class SettingsRolesListController extends Controller {
  @service declare store: StoreService;
  @service declare intl: IntlService;

  declare model: RoleModel[];

  queryParams = ['search'];
  @tracked search = '';

  get roles() {
    let roles = this.model;

    if (this.search) {
      roles = roles.filter((role: RoleModel) => {
        return (role.name ?? '')
          .toLowerCase()
          .includes(this.search.toLowerCase());
      });
    }

    return roles;
  }

  @action
  deleteRole(role: RoleModel) {
    void (role as any).destroyRecord();
  }
}
